/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDCard from "components/MDCard";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getItemMaster,
  getItemStatus,
  getItemStatusDownload,
  getItemTypesForStatus,
  getLocations,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import { addMinutes, format } from "date-fns";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const ItemStatus = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemMaster,
  getItemTypesForStatus,
  itemMaster,
  getItemStatus,
  getItemTypeReducer,

  createDynamicColumn,
  getDynamicColumnReducer,
  getDynamicColumn,
  getItemStatusReducer,
  getItemStatusDownload,
  getLocations,
  getItemStatusDownloadReducer,
  getLocationsReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  const [selectedItemType, setSelectedItemType] = useState("");
  const [selectedItemCode, setSelectedItemCode] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  useEffect(() => {
    getItemTypesForStatus(jwtToken);
  }, []);

  // useEffect(() => {
  //   getItemStatus(
  //     selectedItemType ? selectedItemType.value : "",
  //     selectedItemCode ? selectedItemCode.value : "",
  //     selectedLocation ? selectedLocation.value : "",
  //     jwtToken
  //   );
  // }, [selectedItemType, selectedItemCode, selectedLocation]);

  useEffect(() => {
    getLocations(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let itemStatusReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "95815117-55fd-40be-ab8f-a9407d9ae1df",
  );

  let viewItemStatus = itemStatusReportModule
    ? itemStatusReportModule.actionId.includes(
        "e7b51078-d27b-4bf2-9707-efa327848bad",
      )
    : null;

  const controlOptions = [
    {
      label: "All control",
      value: "",
    },
    {
      label: "No Control",
      value: 0,
    },
    {
      label: "Serial Control",
      value: 1,
    },
    {
      label: "Lot Control",
      value: 2,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Category Code", accessor: "categoryCode" },
      {
        Header: "Control Type",
        accessor: "controlType",
        searchType: "select",
        selectOptions: controlOptions,
        placeholder: "All Control",
      },
      { Header: "Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;
  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    getItemStatus(
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType ? selectedItemType.value : "",
      selectedItemCode ? selectedItemCode.value : "",
      selectedLocation ? selectedLocation.value : "",
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    selectedItemType,
    selectedItemCode,
    selectedLocation,
  ]);
  useEffect(() => {
    getItemStatusDownload(
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType ? selectedItemType.value : "",
      selectedItemCode ? selectedItemCode.value : "",
      selectedLocation ? selectedLocation.value : "",
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    selectedItemType,
    selectedItemCode,
    selectedLocation,
  ]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getItemStatusReducer.itemStatus.data
      ? getItemStatusReducer.itemStatus.data
      : [];
    setLoading(getItemStatusReducer.loading);

    setPaginationObj(getItemStatusReducer.itemStatus?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);

      let len = desLength;
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.itemDescription?.length > 35 ? (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.itemDescription}
              </MDTypography>
            )}
            {finishedGoods?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        categoryCode: finishedGoods.categoryCode,
        documentType: finishedGoods.documentName,
        documentNumber: finishedGoods.documentNumber,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy",
        ),
        cd: finishedGoods.cd,
        controlType:
          (finishedGoods.controlType === 0 && `No Control`) ||
          (finishedGoods.controlType === 1 && `Serial Control`) ||
          (finishedGoods.controlType === 2 && `Lot Control`),
        source: finishedGoods.source,
        destination: finishedGoods.destination,
        qty: `${finishedGoods.qty}`,
        uom: ` ${finishedGoods.uom}`,

        status: (
          <button
            className={
              (finishedGoods.documentStatus === 1 && `status-success`) ||
              (finishedGoods.documentStatus === 2 && `status-info`) ||
              (finishedGoods.documentStatus === 3 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.documentStatus === 1 && `Open`) ||
              (finishedGoods.documentStatus === 2 && `In-Progress`) ||
              (finishedGoods.documentStatus === 3 && `Closed`)}
          </button>
        ),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    // viewFG &&
    setState({ ...state, rows: tempFinishedGoods });
  }, [getItemStatusReducer]);

  const [download, setDownload] = useState("");
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getItemStatusDownloadReducer.itemStatus.data
      ? getItemStatusDownloadReducer.itemStatus.data
      : [];
    // setLoading(getItemStatusDownloadReducer.loading);

    // setPaginationObj(getItemStatusDownloadReducer.itemStatus?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDesc: finishedGoods.itemDescription,
        categoryCode: finishedGoods.categoryCode,
        documentType: finishedGoods.documentName,
        documentNumber: finishedGoods.documentNumber,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa ",
        ),
        cd: finishedGoods.cd,
        controlType:
          (finishedGoods.controlType === 0 && `No Control`) ||
          (finishedGoods.controlType === 1 && `Serial Control`) ||
          (finishedGoods.controlType === 2 && `Lot Control`),
        source: finishedGoods.source,
        destination: finishedGoods.destination,
        qty: `${finishedGoods.qty}`,
        uom: ` ${finishedGoods.uom}`,

        status: (
          <button
            className={
              (finishedGoods.documentStatus === 1 && `status-success`) ||
              (finishedGoods.documentStatus === 2 && `status-info`) ||
              (finishedGoods.documentStatus === 3 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.documentStatus === 1 && `Open`) ||
              (finishedGoods.documentStatus === 2 && `In-Progress`) ||
              (finishedGoods.documentStatus === 3 && `Closed`)}
          </button>
        ),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    // viewFG &&
    setDownload(tempFinishedGoods);
  }, [getItemStatusDownloadReducer]);

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "Item  Description",
      key: "itemDesc",
    },
    { label: "Category Code", key: "categoryCode" },
    { label: "Control Type", key: "controlType" },
    { label: "Qty", key: "qty" },
    { label: "Uom", key: "uom" },
    { label: "createdDate", key: "createdDate2" },
  ];

  const csvLink = {
    filename: "Item Status Report.csv",
    headers: headers,
    data: download,
  };

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
    setSelectedLocation("");
  };
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const handleLocationChange = (selectedItemCode) => {
    setSelectedLocation(selectedItemCode);
  };

  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = getLocationsReducer.locations
      ? getLocationsReducer.locations
      : [];
    data.map((item) => {
      tempItemCodeOptions.push({
        label: item.locationName,
        value: item.locationId,
      });
    });
    setLocationOptions(tempItemCodeOptions);
  }, [getLocationsReducer]);

  const handleItemTypeChange = (selectedOption) => {
    setSelectedItemType(selectedOption);
    setSelectedItemCode("");
    setSelectedLocation("");
    getItemTypesForStatus(jwtToken);
  };
  const itemTypeOptions = [
    { label: "Rejection", value: "REJ" },
    { label: "Quarantine", value: "QA" },
    { label: "RTV", value: "RTV" },
    { label: "Scrap", value: "SCRAP" },
  ];

  const subModuleId = "95815117-55fd-40be-ab8f-a9407d9ae1df";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getItemStatus(
        pageNo,
        rowsPerPage,
        searchObject,
        selectedItemType ? selectedItemType.value : "",
        selectedItemCode ? selectedItemCode.value : "",
        selectedLocation ? selectedLocation.value : "",
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-4}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      mt={2}
                    >
                      <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Type
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={230}
                          options={itemTypeOptions}
                          value={selectedItemType}
                          onChange={handleItemTypeChange}
                        />
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "1000px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Item Code/Des
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          options={itemCodeOptions}
                          value={selectedItemCode}
                          onChange={handleItemCodeChange}
                        />
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Location
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          options={locationOptions}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                        />
                      </MDBox>
                      <MDBox
                        display="flex"
                        alignItems="center"
                        marginLeft={1}
                        marginTop={{ xs: 2, lg: 3 }}
                      >
                        <CSVLink {...csvLink}>
                          <DownloadDataButton
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            style={{ marginLeft: "5px", borderRadius: "5px" }}
                            size="small"
                            tooltip="Download All Data"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getItemTypeReducer: state.getItemTypeReducer,
    getLocationsReducer: state.getLocationsReducer,
    getItemStatusReducer: state.getItemStatusReducer,
    getItemStatusDownloadReducer: state.getItemStatusDownloadReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getItemTypesForStatus: (jwtToken) =>
      dispatch(getItemTypesForStatus(jwtToken)),
    getLocations: (jwtToken) => dispatch(getLocations(jwtToken)),
    // getItemStatus: (
    //   selectedItemType,
    //   selectedItemCode,
    //   selectedLocation,
    //   jwtToken
    // ) =>
    //   dispatch(
    //     getItemStatus(
    //       selectedItemType,
    //       selectedItemCode,
    //       selectedLocation,
    //       jwtToken
    //     )
    //   ),
    getItemStatus: (
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType,
      selectedItemCode,
      selectedLocation,
      jwtToken,
    ) =>
      dispatch(
        getItemStatus(
          pageNo,
          rowsPerPage,
          searchObject,
          selectedItemType,
          selectedItemCode,
          selectedLocation,
          jwtToken,
        ),
      ),
    getItemStatusDownload: (
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType,
      selectedItemCode,
      selectedLocation,
      jwtToken,
    ) =>
      dispatch(
        getItemStatusDownload(
          pageNo,
          rowsPerPage,
          searchObject,
          selectedItemType,
          selectedItemCode,
          selectedLocation,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(ItemStatus);
